import z from "zod";

import {
  CODE_VERIFICATION_CHANNELS,
  CODE_VERIFICATION_SCOPES,
} from "~/common/constants/verificationCode";

export const codeVerificationChannelsSchema = z.enum(
  CODE_VERIFICATION_CHANNELS,
);
export const codeVerificationScopesSchema = z.enum(CODE_VERIFICATION_SCOPES);

export const phoneNumberSchema = z.object({
  number: z
    .string()
    .min(1, "Phone number is required")
    .regex(/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, {
      error: "Please enter number with format: (123) 456-7890",
    }),
  country_code: z.string().min(1, "Country code is required"),
});
